import { render } from "./Group_creation.vue?vue&type=template&id=6cf725b1"
import script from "./Group_creation.vue?vue&type=script&lang=js"
export * from "./Group_creation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__